<elcia-dialog
  (onAction)="onClose.emit()"
  (onClose)="onClose.emit()"
  [actionIcon]="undefined"
  [actionLabel]="'action.close'"
  [mustDisplayCancelButton]="false"
  [size]="'large'"
  [title]="'ai.customer-analysis' | translate">

  @if (isLoading()) {
    <div class="flex flex-col items-center justify-center gap-3 py-16">
      <elcia-loader/>
      <span class="text-sm text-surface-400">{{ 'ai.analysis-in-progress' | translate }}</span>
    </div>
  } @else if (hasFailed()) {
    <p class="text-center py-10 text-surface-400 text-sm italic">{{ 'ai.analysis-failed' | translate }}</p>
  } @else {
    <div class="flex flex-col gap-5">

      <!-- Executive summary -->
      <section class="flex flex-col gap-2">
        <elcia-label [label]="'ai.executive-summary' | translate"/>
        <p class="text-sm leading-relaxed whitespace-pre-line">{{ executiveSummary() }}</p>
      </section>

      <!-- Needs & risks -->
      <div class="flex gap-4">
        <section class="w-1/2 flex flex-col gap-2">
          <elcia-label [label]="'ai.needs' | translate"/>
          @if (needs().length === 0) {
            <span class="text-sm text-surface-400 italic">{{ 'app.no-data' | translate }}</span>
          } @else {
            <ul class="flex flex-col gap-1.5">
              @for (need of needs(); track need) {
                <li class="flex items-start gap-2 text-sm">
                  <span aria-hidden="true" class="pi pi-check text-primary-400 text-xs mt-1"></span>
                  <span>{{ need }}</span>
                </li>
              }
            </ul>
          }
        </section>

        <section class="w-1/2 flex flex-col gap-2">
          <elcia-label [label]="'ai.risks' | translate"/>
          @if (risks().length === 0) {
            <span class="text-sm text-surface-400 italic">{{ 'app.no-data' | translate }}</span>
          } @else {
            <ul class="flex flex-col gap-1.5">
              @for (risk of risks(); track risk) {
                <li class="flex items-start gap-2 text-sm">
                  <span aria-hidden="true" class="pi pi-exclamation-triangle text-orange-500 text-xs mt-1"></span>
                  <span>{{ risk }}</span>
                </li>
              }
            </ul>
          }
        </section>
      </div>

      <!-- Recommended actions -->
      <section class="flex flex-col gap-3">
        <elcia-label [label]="'ai.recommended-actions' | translate"/>
        @if (actions().length === 0) {
          <span class="text-sm text-surface-400 italic">{{ 'ai.no-action' | translate }}</span>
        } @else {
          @for (action of actions(); track action.title) {
            <div class="flex flex-col gap-2 rounded-lg border border-primary-50 p-3">
              <div class="flex items-start justify-between gap-3">
                <span class="text-sm font-bold">{{ action.title }}</span>
                <div class="flex shrink-0 gap-1.5">
                  <elcia-badge [tone]="severityTone(action.priority)">
                    {{ 'ai.priority' | translate }} : {{ 'severity.' + action.priority | translate }}
                  </elcia-badge>
                  <elcia-badge [tone]="severityTone(action.impact)">
                    {{ 'ai.impact' | translate }} : {{ 'severity.' + action.impact | translate }}
                  </elcia-badge>
                  <elcia-badge [tone]="severityTone(action.effort)">
                    {{ 'ai.effort' | translate }} : {{ 'severity.' + action.effort | translate }}
                  </elcia-badge>
                </div>
              </div>
              <p class="text-sm text-surface-600 leading-relaxed">{{ action.description }}</p>
            </div>
          }
        }
      </section>

    </div>
  }
</elcia-dialog>
